import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Simuler un utilisateur connecté pour la démo
  useEffect(() => {
    // En production, on vérifierait le token JWT ou la session
    const user = {
      id: 1,
      nom: 'Jean Dupont',
      email: 'jean.dupont@atl-marseille.fr',
      role: 'admin', // 'admin', 'manager', 'operateur'
      avatar: null,
      permissions: ['livraisons:read', 'livraisons:write', 'clients:read', 'clients:write', 'fournisseurs:read', 'fournisseurs:write', 'rapports:read', 'users:read', 'users:write']
    };
    
    setCurrentUser(user);
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    // Simulation d'une connexion
    // En production, on ferait un appel API
    const user = {
      id: 1,
      nom: 'Jean Dupont',
      email: email,
      role: 'admin',
      avatar: null,
      permissions: ['livraisons:read', 'livraisons:write', 'clients:read', 'clients:write', 'fournisseurs:read', 'fournisseurs:write', 'rapports:read', 'users:read', 'users:write']
    };
    
    setCurrentUser(user);
    localStorage.setItem('user', JSON.stringify(user));
    return user;
  };

  const logout = () => {
    setCurrentUser(null);
    localStorage.removeItem('user');
  };

  const hasPermission = (permission) => {
    if (!currentUser) return false;
    return currentUser.permissions.includes(permission);
  };

  const hasRole = (role) => {
    if (!currentUser) return false;
    return currentUser.role === role;
  };

  const value = {
    currentUser,
    login,
    logout,
    hasPermission,
    hasRole,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}; 